module.exports = __webpack_public_path__ + "static/img/kfh.567ddd69.png";